import React, { useEffect, useState } from 'react'
import SelectField from '../../../../FormControl/input/SelectField'
import { Skeleton, Typography } from '@mui/material'

const SelectRatingType = ({ id, name, value, error, disabled, isPreview, loading, onChange, onClear }) => {
  const data = [
    {
      value: 'age-expected-scale',
      label: 'Age expected scale'
    },
    {
      value: 'learning-objectives-met-scale',
      label: 'Learning objectives met scale'
    },
    {
      value: 'progress-scale',
      label: 'Progress scale'
    }
  ]

  if (isPreview) {
    return <Typography>{data?.find((item) => item.value === value)?.label}</Typography>
  }

  return (
    <SelectField
      id={id}
      error={error}
      helperText={error}
      value={value}
      name={name}
      onChange={onChange}
      onClear={onClear}
      options={data}
      placeholder='Choose a rating type'
      loading={loading}
      disabled={disabled || loading}
    />
  )
}

export default SelectRatingType
